import {
  MutableRefObject,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { MdDragHandle } from "react-icons/md";
import MetaAreaDiv from "../MetaAreaDiv";
import { ProjectInfo } from "../../../../../APITypes/ProjectInfo.cs";
import { RxDragHandleHorizontal } from "react-icons/rx";
import { SessionPlaylistItem } from "@/types";
import { Unplug, Webcam } from "lucide-react";
import { cn } from "../../../../../lib/utils";
import { useDataContext } from "../../../../../app/_context";

const TimeLineTile = forwardRef(
  (
    {
      item,
      index,
      currentSessionIndex,
      onClick,
    }: {
      item: SessionPlaylistItem;
      index: number;
      currentSessionIndex: number;
      onClick: () => void;
    },
    ref,
  ) => {
    const active = index === currentSessionIndex;
    const isBroken = !item.poster;

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            //@ts-ignore
            ref={ref}
            onClick={isBroken ? undefined : onClick}
            disabled={isBroken}
            className={cn(
              "relative rounded-sm aspect-video h-full bg-cover",
              isBroken
                ? "opacity-40 cursor-not-allowed bg-zinc-800"
                : active
                ? "opacity-100 hover:opacity-80"
                : "opacity-70 hover:opacity-80",
            )}
            style={isBroken ? undefined : { backgroundImage: `url(${item.poster})` }}
            key={`${item.poster ?? index}_${item.title ?? index * 2}`}
          >
            {isBroken ? (
              <span className="absolute inset-0 flex items-center justify-center text-zinc-500">
                <Unplug size={20} />
              </span>
            ) : (
              <span className="pointer-events-none text-cyan-500 z-20 flex items-center rounded-tr-sm gap-1 text-xs p-1 bg-black rounded-sm right-0 top-0 absolute">
                <Webcam size={13} /> {item.highlights.length}
              </span>
            )}
            <span
              className={cn(
                "shadow-lg",
                active
                  ? "shadow-purple-800"
                  : "shadow-stone-800 dark:shadow-stone-950",
                "inset-0 z-10 border-2 border-stone-400 absolute pointer-events-none rounded-sm",
              )}
            />
            <span
              className={cn(
                "inset-0 absolute border-4 rounded-sm",
                active && !isBroken ? "border-accent" : "border-transparent",
              )}
            />
          </button>
        </TooltipTrigger>
        <TooltipContent
          align="center"
          className="text-xs bg-white dark:bg-zinc-800"
        >
          {isBroken ? "Unavailable — upload incomplete" : item.title}
        </TooltipContent>
      </Tooltip>
    );
  },
);

export default TimeLineTile;
